import { invalidateAllWorkflowsV2Key } from "./use-get-all-workflows-v2.ts";
import { invalidateShopQueryKey } from "./use-invalidate-shop.ts";
import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates.ts";
import { useApiMutation } from "./use-api-mutation";

export default function useUpsertEmailTemplate(shopId: string) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/tracking-notification/email-template",
		{
			meta: {
				success: {
					title: "notifications.editor.upsert.success.title",
					message: "notifications.editor.upsert.success.message",
				},
				error: {
					title: "notifications.editor.upsert.error.title",
					message: "notifications.editor.upsert.error.message",
				},
				invalidatesQuery: [
					invalidateShopQueryKey(shopId),
					invalidateAllWorkflowsV2Key(shopId),
					invalidateAllShopEmailTemplatesKey(shopId),
				],
			},
			mapVariables: ({ requestBody }: { requestBody: FormData }) => ({
				params: { path: { shopId: shopId } },
				body: requestBody as unknown,
			}),
		},
	);
}
